import React from "react";
import AppointmentsCalendar from "../../../commons/Appointments/AppointmentsCalendar";
import { isAuthenticated } from "../../../commons/Auth/auth";

const Appointments = () => {
  return (
    <>
      <AppointmentsCalendar
        serviceProvider={true}
        serviceProviderId={isAuthenticated()?.serviceProviderId}
      />
    </>
  );
};

export default Appointments;
